var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('select-form-group',{attrs:{"name":"legal_text_id","label":"Legal Text","error":(_vm.errors.legal_text_id || [])[0],"options":_vm.legalTextOptions},model:{value:(_vm.data.legal_text_id),callback:function ($$v) {_vm.$set(_vm.data, "legal_text_id", $$v)},expression:"data.legal_text_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }